import React from 'react';

import { IconProps } from './type';

const DashboardIcon: React.FC<IconProps> = ({ className = '', size = 17 }) => {
  return (
    <svg width={size} viewBox="0 0 17 17" fill="none" className={className}>
      <path d="M3.6 3.6H7.2V7.2H3.6V3.6Z" fill="currentColor" />
      <path d="M9.6 3.6H13.2V7.2H9.6V3.6Z" fill="currentColor" />
      <path d="M3.6 9.6H7.2V13.2H3.6V9.6Z" fill="currentColor" />
      <path d="M9.6 9.6H13.2V13.2H9.6V9.6Z" fill="currentColor" />
    </svg>
  );
};

export default DashboardIcon;
